import React from 'react';
import '../App.css';

const PointsSystem = ({ t }) => {
    return (
        <section className="points-section">
            <h3>{t.pointsSystem}</h3>
            <div className="points-tables">
                <div className="points-table-wrapper">
                    <h4>{t.grandPrix}</h4>
                    <div className="points-grid">
                        <div className="point-item">P1<span>25</span></div>
                        <div className="point-item">P2<span>18</span></div>
                        <div className="point-item">P3<span>15</span></div>
                        <div className="point-item">P4<span>12</span></div>
                        <div className="point-item">P5<span>10</span></div>
                        <div className="point-item">P6<span>8</span></div>
                        <div className="point-item">P7<span>6</span></div>
                        <div className="point-item">P8<span>4</span></div>
                        <div className="point-item">P9<span>2</span></div>
                        <div className="point-item">P10<span>1</span></div>
                    </div>
                </div>
                <div className="points-table-wrapper">
                    <h4>{t.sprintRace}</h4>
                    <div className="points-grid">
                        <div className="point-item">P1<span>8</span></div>
                        <div className="point-item">P2<span>7</span></div>
                        <div className="point-item">P3<span>6</span></div>
                        <div className="point-item">P4<span>5</span></div>
                        <div className="point-item">P5<span>4</span></div>
                        <div className="point-item">P6<span>3</span></div>
                        <div className="point-item">P7<span>2</span></div>
                        <div className="point-item">P8<span>1</span></div>
                    </div>
                </div>
            </div>
        </section>
    );
};

export default PointsSystem;
